class FormieForm {
  constructor(formieForm) {
    this.formieForm = formieForm;
    this.formieFormBody = formieForm.querySelector('[data-formie-form-body]');
    this.formieFormSuccessMessage = formieForm.querySelector(
      '[data-formie-form-success-message]'
    );
    this.init();
  }

  displayFormieForm() {
    this.formieFormSuccessMessage.classList.remove('d-block');
    this.formieFormSuccessMessage.classList.add('d-none');
    this.formieFormBody.classList.remove('d-none');
    this.formieFormBody.classList.add('d-block');
  }

  displaySuccessMessage() {
    this.formieFormSuccessMessage.classList.remove('d-none');
    this.formieFormSuccessMessage.classList.add('d-block');
    this.formieFormBody.classList.remove('d-block');
    this.formieFormBody.classList.add('d-none');
  }

  init() {
    this.formieForm.addEventListener('onAfterFormieSubmit', () => {
      this.displaySuccessMessage();
    });

    // close bs offcanvas when visiting subscribe modal from mobile header.
    this.formieForm.addEventListener('show.bs.modal', () => {
      const offcanvasCloseBtn = document.querySelector(
        '[data-offcanvas-close]'
      );
      offcanvasCloseBtn.click();
    });

    this.formieForm.addEventListener('hidden.bs.modal', () => {
      this.displayFormieForm();
    });

    this.formieForm.addEventListener('hidden.bs.offcanvas', () => {
      this.displayFormieForm();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const formieForms = document.querySelectorAll('[data-formie-form-wrapper]');

  if (formieForms) {
    formieForms.forEach((form) => {
      new FormieForm(form);
    });
  }
});
